import { useClampingText } from '../ClampingText.hooks'

function ClampingTextNodeContent({
  clamped,
  clampingLinesCount,
  fullText,
  setShowExpandButton,
  textClassName,
  ...clampingConfig
}) {
  const { text } = useClampingText({
    ...clampingConfig,
    clamped,
    clampingLinesCount,
    fullText,
    setShowExpandButton,
    textClassName,
  })

  return text
}

export default ClampingTextNodeContent
